import { render, staticRenderFns } from "./NotSupportedBrowserModal.vue?vue&type=template&id=09425476&scoped=true"
import script from "./NotSupportedBrowserModal.vue?vue&type=script&lang=js"
export * from "./NotSupportedBrowserModal.vue?vue&type=script&lang=js"
import style0 from "./NotSupportedBrowserModal.vue?vue&type=style&index=0&id=09425476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09425476",
  null
  
)

export default component.exports